import useChatInbox from '@/Sparrow/Hooks/useChatInbox';
import { usePage } from '@inertiajs/vue3';
import { isDefined } from '@vueuse/core';
import { watch } from 'vue';

const useAuthenticationObserver = () => {
  const page = usePage();

  watch(() => page.props?.user?.id, (newUserId, prevUserId) => {
    if (isDefined(prevUserId) && newUserId !== prevUserId) {
      // Reset all chat inbox instances when auth state changes
      useChatInbox.resetInstances();
    }
  }, {
    immediate: true,
    deep: true,
  });

  return {};
};

export default useAuthenticationObserver;
